import {useSyncExternalStore} from 'react';
import {messageVariants} from '../../../envisia/main/stream/stream.model';
import {EvButton} from '../../form/EvButton';
import {PriceDebugMessageStore} from './price-debug-message-store';

interface Props {
  store: PriceDebugMessageStore;
}

export function PriceDebugConsole(props: Props) {
  const messages = useSyncExternalStore(props.store.subscribe, props.store.getSnapshot);

  return <div className="flex h-dvh flex-col bg-black p-2">
    <div className="relative w-full h-0">
      <EvButton type="button" className="absolute top-0 right-0" onClick={props.store.clear}>
        Leeren
      </EvButton>
    </div>
    <div className="flex-1 overflow-y-auto font-mono snap-y snap-proximity [overflow-anchor:none]">
      {messages.map((messageBlock, messageBlockIndex) =>
        <div key={messageBlockIndex} className="border border-solid border-white">
          <div className="text-white border-0 border-white border-b">
            {(messages.length - messageBlockIndex === 1) ?
              'Letzte kalkulation' : `Vor ${messages.length - messageBlockIndex - 1} Kalkulationen`}
          </div>
          {messageBlock.map((message, messageIndex) =>
            <div key={messageIndex} className={messageVariants({code: message.code})}>
              {message.msg}
            </div>,
          )}
        </div>,
      )}
      <div className="snap-end h-px"></div>
    </div>
  </div>;
}
